import { PREVIEW_COLORS } from './constants';
import playMomentsLogo from './header-playmoments.svg';
import cloudCharacter from './header-cloud.svg';
import avatarIcon from './avatar.svg';

export default function PreviewHeader() {
  return (
    <div
      className="flex items-center justify-between px-6 py-2 flex-shrink-0"
      style={{ backgroundColor: PREVIEW_COLORS.headerBg, height: '77px' }}
    >
      <img src={playMomentsLogo} alt="" style={{ width: '95px', height: '61px' }} />
      <div className="flex items-center gap-4">
        <img src={cloudCharacter} alt="" style={{ width: '57px', height: '36px' }} />
        <div className="rounded-full overflow-hidden" style={{ width: '36px', height: '36px' }}>
          <img src={avatarIcon} alt="" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
}
